import type { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import type { Project } from '@teemill/projects';

import { faIndustryWindows } from '@fortawesome/pro-light-svg-icons';

export const projectType = <T extends Pick<Project, 'integrations'>>(
  project: T,
): {
  name: string;
  icon: IconDefinition;
} => {
  const integrations = project.integrations;

  if (integrations === undefined) {
    return {
      name: 'Unknown',
      icon: faIndustryWindows,
    };
  }

  if (integrations.includes('fulfillments')) {
    return {
      name: 'Factory',
      icon: faIndustryWindows,
    };
  }

  return {
    name: 'Project',
    icon: faIndustryWindows,
  };
};
